import React, { useState } from "react";
import PropTypes from "prop-types";
import { IconButton, Menu, MenuItem, Checkbox, ListItemText, Tooltip } from "@mui/material";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { useLanguage } from "context/LanguageContext";

function ColumnManager({ allColumns }) {
  const { t } = useLanguage();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={t("manageColumns") || "Manage Columns"}>
        <IconButton onClick={handleClick} color="primary" size="small" sx={{ p: 0.75 }}>
          <ViewColumnIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 400,
            width: "250px",
          },
        }}
      >
        {allColumns.map((column) => {
          // Skip columns that shouldn't be toggled
          if (column.id === "selection" || column.id === "processing" || column.id === "id") {
            return null;
          }
          return (
            <MenuItem
              key={column.id}
              onClick={(e) => {
                e.preventDefault();
                column.toggleHidden();
              }}
            >
              <Checkbox
                checked={column.isVisible}
                color="primary"
                style={{ padding: "4px 8px 4px 0" }}
              />
              <ListItemText
                primary={typeof column.Header === "string" ? column.Header : column.id}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}

ColumnManager.propTypes = {
  allColumns: PropTypes.array.isRequired,
};

export default ColumnManager;
